import $ from "jquery/src/jquery";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default () => {
    const nodeSelectors = {
        container: '[js-animation-magnet="container"]',
        item: '[js-animation-magnet="button"]',
    };

    const itemRects = new WeakMap();

    function init() {
        const containers = document.querySelectorAll(nodeSelectors.container);
        if (!containers.length) return;

        containers.forEach(container => {
            const item = container.querySelector(nodeSelectors.item);
            if (!item) return;


            // --- Settings (percentages)
            const radiusPercent = { x: 2, y: 2 }; // 120% of width/height
            const strengthPercent = { x: 1.5, y: 1.5 }; // 15% of width/height max move
            const hoverScale = 1;

            const updateRect = () => {
                itemRects.set(item, item.getBoundingClientRect());
            };

            updateRect();
            window.addEventListener("resize", updateRect, { passive: true });
            window.addEventListener("scroll", updateRect, { passive: true });

            let isInside = false;

            const onMove = (e) => {
                const rect = itemRects.get(item);
                if (!rect || rect.width === 0) return;

                const x = e.clientX;
                const y = e.clientY;
                const cx = rect.left + rect.width / 2;
                const cy = rect.top + rect.height / 2;
                const dx = x - cx;
                const dy = y - cy;

                // --- Proportional radius
                const radiusX = rect.width * (radiusPercent.x / 2);
                const radiusY = rect.height * (radiusPercent.y / 2);

                // --- Elliptical magnet zone detection
                const distRatio = Math.sqrt((dx * dx) / (radiusX * radiusX) + (dy * dy) / (radiusY * radiusY));

                if (distRatio < 1) {
                    isInside = true;
                    const strengthRatio = 1 - distRatio;

                    // --- Strength now also proportional to element size
                    const maxTx = rect.width * strengthPercent.x;
                    const maxTy = rect.height * strengthPercent.y;

                    const tx = (dx / radiusX) * maxTx * strengthRatio;
                    const ty = (dy / radiusY) * maxTy * strengthRatio;

                    gsap.to(item, {
                        x: tx,
                        y: ty,
                        scale: hoverScale,
                        duration: 0.3,
                        ease: "power3.out",
                        overwrite: "auto",
                    });
                } else if (isInside) {
                    isInside = false;
                    gsap.to(item, {
                        x: 0,
                        y: 0,
                        scale: 1,
                        duration: 0.5,
                        ease: "elastic.out(1, 0.45)",
                        overwrite: "auto",
                    });
                }
            };

            const onLeave = () => {
                isInside = false;
                gsap.to(item, {
                    x: 0,
                    y: 0,
                    scale: 1,
                    duration: 0.5,
                    ease: "elastic.out(1, 0.45)",
                    overwrite: "auto",
                });
            };

            window.addEventListener("mousemove", onMove, { passive: true });
            item.addEventListener("mouseleave", onLeave);
        });
    }

    function updateRects() {
        document.querySelectorAll(nodeSelectors.item).forEach(item => {
            itemRects.set(item, item.getBoundingClientRect());
        });
    }

    return Object.freeze({
        init,
        updateRects,
    });
};